import * as Yup from "yup";

export const tenantDepostSchema = Yup.object().shape({
  sourceCurrencyCode: Yup.string().required("Source Currency is Required"),
  targetCurrencyCode: Yup.string().required("Target Currency is Required"),
  addAmount: Yup.string().required("Amount is Required"),
  toOwnerType: Yup.string().required("Target type is Required"),
});

export const createEditDepositBankingDetailsSchema = Yup.object().shape({
  accountHolderName: Yup.string(),
  rtNumber: Yup.string(), // optional
  place: Yup.string(), // optional
  bankName: Yup.string().required("Bank Name is Required"),
  accountNumber: Yup.string().required("Account Number is Required"),
  // optional
  accountType: Yup.string().required("Account Type is Required"),

  status: Yup.boolean().required("Status is Required"),
});

export const createEditWithdrawalBankingDetailsSchema = Yup.object().shape({
  bankName: Yup.string().required("Bank Name is Required"),
  rtNumber: Yup.string().required("RT Number is Required"),
  status: Yup.boolean().required("Status is Required"),
});
